<template>
  <b-form>
    <template v-if="isInline">
      <b-input-group>
        <template v-slot:prepend>
          <b-input-group-text class="bg-white p-1">
            <span class="small d-flex justify-content-center align-items-center"><rewards-coin/></span>
          </b-input-group-text>
        </template>
        <b-select :options="coinDenominations" size="sm" v-model="selectedCoinDenomination"
          :disabled="coinDenominations[0] && coinDenominations[0].disabled"/>
        <!-- template v-slot:append>
          <b-select class="ml-2" :options="quantities" size="sm" v-model="selectedQuantity"
            :disabled="quantities[0] && quantities[0].disabled"/>
        </template -->
      </b-input-group>
      <b-btn class="mt-3 w-100" :disabled="disabled || coinBalance < selectedTokenCost"
        @click="triggerClaim" variant="primary">Claim Reward</b-btn>
    </template>
    <template v-else>
      <b-form-group label="Denomination" label-for="valueDenominations">
        <b-input-group>
          <template v-slot:prepend>
            <b-input-group-text class="bg-white d-flex justify-content-center align-items-center p-1">
              <rewards-coin/>
            </b-input-group-text>
          </template>
          <b-select :options="coinDenominations" v-model="selectedCoinDenomination"
            :disabled="coinDenominations[0] && coinDenominations[0].disabled"/>
        </b-input-group>
      </b-form-group>
      <!-- b-form-group label="Quantity" label-for="quantity">
        <b-select :options="quantities" v-model="selectedQuantity"
          :disabled="quantities[0] && quantities[0].disabled"/>
      </b-form-group -->
      <b-btn class="w-100" :disabled="disabled || coinBalance < selectedTokenCost"
        @click="triggerClaim" variant="primary">Claim Reward</b-btn>
    </template>
  </b-form>
</template>

<script>
import { RewardsCoin } from '@src/components/Icons';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    isInline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    coinBalance: {
      type: Number,
      required: true,
    },
    valueDenominations: {
      type: [ String, Array ],
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
    exchangeRate: {
      type: Number,
      default: 1,
    },
  },
  components: {
    RewardsCoin,
  },
  data: () => ({
    coinDenominations: [],
    selectedCoinDenomination: null,
    selectedQuantity: null,
  }),
  created() {
    const { preferences, sitePreferences } = this.company;
    const { rewardCoinConversionRate } = { ...preferences, ...sitePreferences };
    const { currencyCode } = this;
    const currency = p => {
      switch (currencyCode) {
        case 'GBP':
          return `£${p}`;
        case 'USD':
          return `$${p}`;
        case 'EUR':
          return `€${p}`;
        default:
          return `${p} ${currencyCode}`;
      }
    };

    this.coinDenominations = this.parsedValueDenominations.map(amount => {
      const price = amount * (typeof this.exchangeRate === 'number' ? this.exchangeRate : 1);
      const originalPrice = amount;
      return {
        text: `${Math.ceil(price / rewardCoinConversionRate)} (${currency(originalPrice)})`,
        value: Math.ceil(price / rewardCoinConversionRate),
      };
    });

    this.selectedCoinDenomination = Array.isArray(this.coinDenominations) && this.coinDenominations.length
      ? (this.coinDenominations.slice(0, 1).shift() ? this.coinDenominations.slice(0, 1).shift().value : null)
      : null;
    this.selectedQuantity = 1;
  },
  computed: {
    ...mapRoot([ 'company' ]),
    parsedValueDenominations() {
      const { valueDenominations: values } = this;
      return (Array.isArray(values) ? values : `${values}`.split(',').map(value => parseFloat(value))).reverse();
    },
    selectedTokenCost() {
      return this.selectedCoinDenomination * this.selectedQuantity;
    },
    selectedValueDenomination() {
      const i = this.coinDenominations.map(({ value }) => value).indexOf(this.selectedCoinDenomination);
      return i >= 0 ? this.parsedValueDenominations[i] : null;
    },
    quantities() {
      return Array.from(Array(50)).map((v, i) => i + 1);
    },
  },
  methods: {
    triggerClaim() {
      const { selectedTokenCost: tokenCost, selectedValueDenomination: denomination, selectedQuantity: quantity } = this;
      this.$emit('claim', { denomination, quantity, tokenCost });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rewards/ChooseDenominations.vue